import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import TableRow from "@material-ui/core/TableRow";
import TableFooter from "@material-ui/core/TableFooter";
import MUITablePagination from "@material-ui/core/TablePagination";
import withStyles from "components/with-styles";
import styles from "./styles/table-pagination.css.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { injectIntl } from "react-intl";
import { rowsPerPageOptions } from "../context";
import { onChangePage as updateRouteOnChangePage } from "components/table";
import { withRouter } from "react-router-dom";

const TablePagination = ({
  intl,
  classes,
  show,
  total,
  perPage,
  page = 0,
  onChangePage,
  onChangePerPage,
  history,
  pageName,
  location: { search },
  isUrlPagination = true,
}) => {
  const matchesMobile = useMediaQuery("(max-width: 600px)");

  const handleChangePage = (ev, page) => {
    isUrlPagination && updateRouteOnChangePage({ pageName, page, query: search, history });
    if (onChangePage) {
      onChangePage(page);
    }
  };

  const handleChangePerPage = ev => {
    isUrlPagination && updateRouteOnChangePage({ pageName, page: 0, query: search, history });
    onChangePerPage(ev);
  };

  return show ? (
    <TableFooter>
      <TableRow>
        <MUITablePagination
          labelRowsPerPage={intl.formatMessage({ id: "common.table.labelRowsPerPage" })}
          labelDisplayedRows={({ from, to, count }) =>
            intl.formatMessage({ id: "common.table.labelDisplayedRows" }, { from, to, count })
          }
          count={parseInt(total)}
          rowsPerPageOptions={rowsPerPageOptions}
          rowsPerPage={perPage}
          page={page || 0}
          SelectProps={{
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangePerPage}
          classes={{
            root: classes.root,
            toolbar: cn(classes.toolbar, { [classes.toolbar_mobile]: matchesMobile }),
            caption: classes.caption,
            actions: classes.actions,
          }}
        />
      </TableRow>
    </TableFooter>
  ) : null;
};

TablePagination.propTypes = {
  /**
   * Total de elementos paginados
   **/
  total: PropTypes.number,
  /**
   * Página de la tabla que se está mostrando
   **/
  page: PropTypes.number,
  /**
   * Nombre del parámetro de query en la url que representa el paginado de esta tabla
   **/
  pageName: PropTypes.string,
  /**
   * Número de elementos por página
   **/
  perPage: PropTypes.number.isRequired,
  /**
   * Handler del cambio de página
   **/
  onChangePage: PropTypes.func,
  /**
   * Handler del cambio de elementos por página
   **/
  onChangePerPage: PropTypes.func,
  /**
   * Muestra o no los controles de paginación
   **/
  show: PropTypes.bool,
  /**
   * Muestra o no los controles de paginación
   **/
  isUrlPagination: PropTypes.bool,
};

export default withStyles(styles)(injectIntl(withRouter(TablePagination)));
